import axios from "@/plugins/untils.js";



// /* 简历列表 */
// export const api_queryHrResumeTemplateList = (params) => {
//     return axios.post('/web/queryNewsIndex', params)
// }

/* 登录 */
export const api_authLogin = (params) => {
    return axios.post('/web/login/authLogin', params)
}

/* 登录 */
export const api_queryWxInfo = (params) => {
    return axios.get('/web/login/queryWxInfo', { params })
}
/* 分类列表 */
export const getCategoryList = (params) => {
    return axios.post('/web/aiInterviewB/news/selectNewsCategoryList', { params })
}
/* 新闻列表 */
export const getNewsList = (data = {}) => {
    return axios.post('/web/aiInterviewB/news/selectNewsList', data)
}
/* 新闻详情 */
export const getNewsDetail = (data = {}) => {
    return axios.post('/web/aiInterviewB/news/selectNewsById', data)
}
/*相关新闻 */
export const getRelatedNews = (data = {}) => {
    return axios.post('/web/aiInterviewB/news/selectRelatedNewsById', data)
}
/*热门新闻 */
export const getHotNews = (data = {}) => {
    return axios.post('/web/aiInterviewB/news/selectHotNewsList', data)
}
/* 报名 */
export const addFinanceInfo = (data = {}) => {
    return axios.post('/web/services/addFinanceInfo', data)
}

/* 常见问题 */
export const questionList = (data = {}) => {
    return axios.post('/web/aiInterviewB/question/questionList', data)
}
/* 行业 */
export const caseIndustryList = (data = {}) => {
    return axios.post('/web/aiInterviewB/caseShow/caseIndustryList', data)
}

/* 案例列表 */
export const caseShowList = (data = {}) => {
    return axios.post('/web/aiInterviewB/caseShow/caseShowList', data)
}

/* 用户行为埋点 */ 
export const addEventLog = (data = {}) => {
    return axios.post('/web/aiInterviewB/hrEventLog/addEventLog', data)
}

/* 获取悬赏招聘前6列表 */
export const queryTopPriceCompanyHeadList = (data = {}) => {
    return axios.get('/web/aiInterviewB/headhunting/queryTopPriceCompanyHeadList', data)
}
/* 获取行业 */
export const queryCompanyType = (data = {}) => {
    return axios.post('/web/aiInterviewBUser/queryCompanyType', data)
}
/* 提交信息 */
export const saveCustomerRegister = (data = {}) => {
    return axios.post('/web/aiInterviewB/customerRegister/save', data)
}
/* 获取b端小程序地址 */
export const jumpBUrl = (data = {}) => {
    return axios.get('/web/appletUrl/jumpBUrl', data)
}

